import type { ConversationStats } from 'types/stats.js';

export async function fetchConversationStats(): Promise<ConversationStats> {
  try {
    const res = await fetch('/api/stat', {
      method: 'GET',
      credentials: 'include',
    });

    if (!res.ok) {
      return [];
    }

    const data = (await res.json()) as ConversationStats;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
